export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-photo-b2474879666ad475140408d03658cf05.svg";